import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const Netlify = () =>{


    return(
    
        <div id="articleContent">
        <h2 class="code-line"><a id="Publier_un_site_statique_basique_sur_Netlify_2"></a>Publier un site statique basique sur Netlify</h2>
                    <ol>
                    <li>Aller sur la home de l’espace perso Netlify et cliquer sur le bouton New site from Git</li>
                    <li><em>Create a new site - Connect to Git provider</em> - Pour continuer le déploiement, cliquer sur le bouton GitHub (si le repository est sur GitHub).</li>
                    <li>Parfois le dépôt que l’on souhaite déployer n’est pas visible. Pour cela il faut cliquer sur le lien du bas <strong>Configure the Netlify app on GitHub</strong> puis sur GitHub aller sur <strong>Repository access</strong> (tout en bas) et cliquer sur le bouton Select repository pour autoriser l’accès au repository en question puis sauvegarder.</li>
                    <li><em>Create a news site - Pick a repository</em> - Sur Netlify, continuer le déploiement en seléctionnant le dépôt en question</li>
                    <li><em>Create a news site - Build option, and deploy !</em> - Cliquer sur le bouton Deploy site, sans rien modifier de ce qui est proposé par défaut.<br/>
                    <strong>Attention ! Pour empêcher Netlify de traiter les avertissements comme des erreurs remplacer dans build commande CI= npm run prod</strong><br/>
                    <strong>Attention, il doit y avoir un fichier index.html pour que cela fonctionne</strong></li>
                    </ol>
                    
                    <h2><a></a>Publier un site React sur Netlify</h2>
                    <p  data-line-start="12" data-line-end="13"><strong>Git est déjà initialisé sur React mais il faut git add .eslintcache pour qu’il puisse être commité</strong></p>
                    <ol>
                    <li>Commit le projet React</li>
                    <li>Le pusher sur un dépôt Github en suivant les instructions sur Github</li>
                    <li>Suivre les mêmes instructions que pour un site basique</li>
                    <li>Sauf qu’il y a des paramètres différents dans l’étape <strong>Basic build settings</strong>, dans build commande laisser <strong>npm run build</strong> et dans Publish directory <strong>build/</strong><br/>
                    <strong>Attention ! Pour empêcher Netlify de traiter les avertissements comme des erreurs remplacer dans build commande CI= npm run build</strong></li>
                    </ol>
                    
                    <h2><a></a>Comment modifier l’url créé par défaut du nouveau projet</h2>
                    <ol>
                    <li>Aller dans <strong>site settings</strong></li>
                    <li>Dans site information, cliquer sur le bouton <strong>Change site name</strong></li>
                    <li>Procéder au changement et cliquer sur le bouton <strong>save</strong></li>
                    </ol>

      </div>
    )
}
